module.exports = __webpack_public_path__ + "static/scale-model-of-ernest-hemingway-birthplace-museum-in-chicago-illinois-a615a35a80040b57f6a2c4eab947d8b1.png";